import { useEffect, useState } from "react";
import {
  Button,
  Grid,
  ImpressoraAdd,
  MenuButtonList,
  Typography,
} from "../../../../components";
import { PermisoesHelper } from "../../../../helpers";
import { ModeloNfeEspelho } from "./modelos-impressao";
import MenuAddActions from "./menu-add-actions.component";
import { Calculo_DV11, GeraCodigoNumerico } from "../add-nf-saida";
import { format } from "date-fns";
import constantes from "../resources/constantes";
import {
  ImpressoraService,
  NfSaidaService,
  notification,
  SessionService,
} from "../../../../services";
import EnvioWhatsappNfeDialog from "./dialogComponents/EnvioWhatsappDialog";
import { useImportContext } from "../../../../contexts/import.context";
import { responseErros } from "../../../../utils";

const nfSaidaService = new NfSaidaService();

const ButtonMenu = ({
  id,
  nfSaida,
  onClickCancelarNfSaida,
  onClickEmitirNfSaida,
  onClickCriarContingenciaNfSaidaPendente,
  onClickValidarNfSaida,
  onClickCartaCorrecao,
  onClickConsultarStatus,
  onClickBaixarXml,
  operacaoFiscal,
  permissaoCancelar,
  openDialogEnvioWhatsapp,
  setOpenDialogEnvioWhatsapp,
  setLoading,
}) => {
  const { initialCollapses } = useImportContext();
  const [anchorEl, setAnchorEl] = useState(null);
  const [dataImpressaoEspelho, setDataImpressaoEspelho] = useState(nfSaida);
  const permisoesHelper = new PermisoesHelper();
  const sessionService = new SessionService();
  const empresa = sessionService.getEmpresaRelatorio();
  const impressoraService = new ImpressoraService();
  const permisoesNfSaidaCancelar =
    permisoesHelper.temPermisao("nf-saida-cancelar");
  const isMenuOpen = Boolean(anchorEl);
  const menuId = "primary-add-actions-menu";
  const permissaoEmitir = getPermissaoEmitir(nfSaida, operacaoFiscal);

  const opcoesMenu = [
    { label: "Validar DF-e", onClick: onClickValidarNfSaida },
    ...getOpcoesCancelamento(),
  ];

  useEffect(() => {
    if (mostraUpdateDataImpressao()) {
      updateDataImpressaoEspelho();
    }
  }, [nfSaida.numeroDocumento, nfSaida.serieDocumento]);

  async function buscarDanfe() {
    setLoading(true);
    const result =
      nfSaida.status === "CONTINGENCIA"
        ? await nfSaidaService.getDanfeContingencia(id, empresa)
        : await nfSaidaService.getDanfe(id);
    setLoading(false);
    if (!result.isAxiosError) {
      if (
        nfSaida.modeloDocumento === "65" &&
        nfSaida.empresa.configuracoes?.impressaoDiretaNf
      ) {
        print(result.data);
      } else {
        openAbaDanfeBase64(result.data);
      }
    } else {
      responseErros(result);
    }
  }

  async function buscarDanfeSecundaria() {
    setLoading(true);
    const result = await nfSaidaService.getDanfeSecundaria(id, empresa);
    setLoading(false);
    if (!result.isAxiosError) {
      if (nfSaida.empresa.configuracoes?.impressaoDiretaNf) {
        print(result.data);
      } else {
        openAbaDanfeBase64(result.data);
      }
    } else {
      responseErros(result);
    }
  }

  async function print(base64Pdf) {
    setLoading(true);
    try {
      if (!base64Pdf) {
        notification.erroGenericos("Erro ao gerar imagem para impressão.");
        return;
      }
      const body = {
        base64Pdf,
        printerName: nfSaida.empresa?.configuracoes?.impressoraTermica || null,
      };
      const resultImpressao = await impressoraService.imprimirTermicaPdf(body);
      if (!resultImpressao.isAxiosError) {
        notification.sucessoGenericos("Impressão realizada com sucesso!");
      } else {
        responseErros(resultImpressao);
      }
    } catch (error) {
      console.error("Erro na impressão:", error);
      notification.erroGenericos("Erro ao realizar a impressão.");
    } finally {
      setLoading(false);
    }
  }

  async function openAbaDanfeBase64(base64Pdf) {
    try {
      const response = await fetch(`data:application/pdf;base64,${base64Pdf}`);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const pdfWindow = window.open(url, "_blank");
      if (!pdfWindow) {
        notification.alertaGenericos(
          "Popup bloqueado - por favor permita popups para este site"
        );
      }

      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (error) {
      console.error("Erro ao abrir PDF:", error);
      throw error;
    }
  }

  function getPermissaoEmitir(nfSaida, operacaoFiscal) {
    const { modeloDocumento } = operacaoFiscal;
    const { empresa } = nfSaida;

    return (
      (modeloDocumento === "65" && empresa?.emiteNfce) ||
      (modeloDocumento === "55" && empresa?.emiteNfe)
    );
  }

  function getOpcoesCancelamento() {
    if (nfSaida.status === "PENDENTE" && permissaoCancelar) {
      return [
        {
          label: "Cancelar DF-e",
          onClick: onClickCancelarNfSaida,
          disabled: !permisoesNfSaidaCancelar,
        },
      ];
    }
    return [];
  }

  const gerarChaveAcesso = (nfSaida) => {
    if (!nfSaida) return "";

    const { numeroDocumento, serieDocumento, empresa } = nfSaida;
    const uf =
      constantes.estados.find((e) => e.sigla === empresa.uf)?.cod || "";
    const cnpj = empresa?.cnpjCpf || "";

    const numeroFormatado = numeroDocumento?.toString().padStart(9, "0");
    const data = format(new Date(), "yyMM");
    const codigoNumerico = GeraCodigoNumerico(new Date());

    const initKey = `${uf}${data}${cnpj}55${serieDocumento}${numeroFormatado}1${codigoNumerico}`;
    return initKey + Calculo_DV11(initKey);
  };

  const mostraUpdateDataImpressao = () =>
    id && nfSaida.numeroDocumento && nfSaida.serieDocumento;

  const updateDataImpressaoEspelho = () => {
    setDataImpressaoEspelho({
      ...nfSaida,
      chaveAcesso: gerarChaveAcesso(nfSaida),
    });
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const renderMainButtons = () => {
    if (!id) return null;

    const { status } = nfSaida;

    return (
      <>
        {renderVisualizarButton(status)}
        {renderEspelhoButton(status)}
        {renderStatusButton(status)}
        {renderEmitirButtons(status)}
        {/* {renderWhatsappButton()} */}
        {renderMoreActionsButton()}
      </>
    );
  };

  const renderVisualizarButton = (status) => {
    const hiddenStatus = ["PENDENTE", "EM PROCESSAMENTO", "FATURADA"];

    if (!hiddenStatus.includes(status)) {
      return (
        <Button
          id="danfeButton"
          className="my-3"
          variant="outlined"
          color="primary"
          size="small"
          onClick={() => {
            buscarDanfe();
          }}
        >
          Visualizar DF-e
        </Button>
      );
    }
  };

  const renderEspelhoButton = (status) => {
    if (status === "PENDENTE" && nfSaida?.modeloDocumento === "55") {
      return (
        <ImpressoraAdd
          descricaoBotao="Espelho DF-e"
          LayoutImpressao={
            dataImpressaoEspelho && (
              <ModeloNfeEspelho data={dataImpressaoEspelho} />
            )
          }
        />
      );
    }
  };

  const renderStatusButton = (status) => {
    if (status === "EM PROCESSAMENTO") {
      return (
        <Button
          className="my-3 ms-2"
          variant="outlined"
          color="primary"
          size="small"
          onClick={onClickConsultarStatus}
        >
          Consultar DF-e
        </Button>
      );
    }
  };

  const renderEmitirButtons = (status) => {
    if (["PENDENTE", "CONTINGENCIA"].includes(status)) {
      return (
        <>
          {status === "PENDENTE" && nfSaida?.modeloDocumento !== "55" && (
            <Button
              className="my-3 ms-2"
              variant="outlined"
              color="primary"
              size="small"
              disabled={!permissaoEmitir}
              onClick={onClickCriarContingenciaNfSaidaPendente}
            >
              Emitir DF-e em Contingência
            </Button>
          )}
          <MenuButtonList
            className="my-3 ms-2"
            botaoPrincipal={{
              onClick: onClickEmitirNfSaida,
              label: "Emitir DF-e",
            }}
            disabled={!permissaoEmitir}
            opcoes={opcoesMenu}
          />
        </>
      );
    }
  };

  const renderMoreActionsButton = () => (
    <Button
      aria-label="add action caixa"
      aria-controls={menuId}
      aria-haspopup="true"
      aria-expanded={isMenuOpen ? "true" : "false"}
      onClick={handleMenuOpen}
      color="inherit"
      style={buttonStyle}
    >
      <span style={{ fontSize: 10 }}>mais ações</span>
    </Button>
  );

  const buttonStyle = {
    borderRadius: 5,
    backgroundColor: "#E5E5E5",
    margin: "1em",
  };

  return (
    <>
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        sx={{ mb: "0.5em" }}
      >
        {renderMainButtons()}
        <div className="invisible" style={{ width: 5, height: 5 }}>
          <ImpressoraAdd descricaoBotao="Visualizar DF-e" />
        </div>
        {nfSaida.status === "CANCELADO" && (
          <Typography style={{ color: "red" }}>CANCELADO</Typography>
        )}
      </Grid>
      <MenuAddActions
        id={id}
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        nfSaida={nfSaida}
        onClickCancelarNfSaida={onClickCancelarNfSaida}
        onClickCartaCorrecao={onClickCartaCorrecao}
        onClickBaixarXml={onClickBaixarXml}
        permissaoCancelar={permissaoCancelar}
        configuracoes={nfSaida?.empresa?.configuracoes}
        buscarDanfeSecundaria={buscarDanfeSecundaria}
      />
      <EnvioWhatsappNfeDialog
        open={openDialogEnvioWhatsapp}
        setOpen={setOpenDialogEnvioWhatsapp}
        nfSaida={nfSaida}
        initialCollapses={initialCollapses}
      />
    </>
  );
};

export default ButtonMenu;
